/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-passion-1': {
    width: 32,
    height: 51,
    viewBox: '0 0 32 51',
    data: '<path pid="0" class="st0" d="M24.4 47.2H6.8L5.5 33h20.2l-1.3 14.2zM2.9 23.6h25.4v6.5H2.9v-6.5zM18.7 4.8C20.2 3.3 22.3 3 23.8 3c.4 0 .8 0 1.1.1 0 1.9-.2 4.9-1.6 6.4-1.5 1.5-3.6 1.8-5.1 1.8-.5 0-.9 0-1.2-.1-.3-1.5-.3-4.5 1.7-6.4m11.1 15.9H17.1v-6.5h1.1c2.1 0 5-.5 7.2-2.7 1.4-1.4 2.2-3.5 2.4-6.2.2-2 0-3.6 0-3.6-.1-.6-.5-1.1-1.1-1.3 0 0-1.2-.3-2.9-.3-2.1 0-5 .5-7.2 2.7-3.5 3.5-2.7 8.8-2.4 9.9v8.1H1.5c-.8 0-1.5.7-1.5 1.5v9.4c0 .7.7 1.3 1.5 1.3h1.1L4 48.8c.1.8.7 1.3 1.5 1.3h20.3c.8 0 1.4-.6 1.5-1.3L28.7 33h1.1c.8 0 1.5-.7 1.5-1.5v-9.4c0-.8-.7-1.4-1.5-1.4"/>'
  }
})
